import { Component, Input } from '@angular/core';
import { map } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AsyncPipe, NgClass } from '@angular/common';

@Component({
  selector: 'wm-libs-balance-block',
  templateUrl: './balance-block.component.html',
  styleUrls: ['./balance-block.component.scss'],
  standalone: true,
  imports: [MatIconModule, NgClass, AsyncPipe],
})
export class BalanceBlockComponent {
  hideBalance = true;
  @Input() balance!: number;

  isMobile$ = this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(map((result) => result.matches));

  constructor(private breakpointObserver: BreakpointObserver) {}
}
